import { render, staticRenderFns } from "./Datatable2Select.vue?vue&type=template&id=5e25dd76&"
import script from "./Datatable2Select.vue?vue&type=script&lang=js&"
export * from "./Datatable2Select.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports